<template>
  <div class="pre_page">
    <img class="pre_bg" :src="require(`../assets/pre/${language}/pre_bg.png`)" alt="">
    <iframe class="video" ref="video" :id="'youtube-player-' + Date.now()" 
      :src="`https://www.youtube.com/embed/dzWvsKdxPmE?enablejsapi=1&autoplay=1&mute=1&controls=0&rel=0&loop=1&playlist=dzWvsKdxPmE`"
      frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      @load="onVideoLoad">
    </iframe>
    <a href="javascript:;" class="earth" @click="toHome"><img :src="require(`../assets/pre/${language}/earth.png`)"
        alt=""></a>
    <a class="down_btn" target="_blank" href="https://sunm.onelink.me/P0bp/fwh2i6fp" name="submit" v-if="isIOS" @click="submit">
      <img :src="require(`../assets/pre/${language}/appstore.png`)" alt="">
    </a>
    <a class="down_btn" target="_blank" href="https://sunm.onelink.me/P0bp/fwh2i6fp" name="submit" v-else @click="submit">
      <img :src="require(`../assets/pre/${language}/google.png`)" alt="">
    </a>
    <a href="javascript:;" class="claim" @click="toHome">
      <img :src="require(`../assets/pre/${language}/claim.png`)" alt="">
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { generateTrackingConfig } from '@/utils/tracking'
export default {
  metaInfo() {
    return generateTrackingConfig('GTM-MH8DLNWZ', '769880892414304','D2V7073C77U1Q4B3AJOG')
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters(['language']),
    isIOS() {
      let u = navigator.userAgent;
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      return isIOS;
    }
  },
  created() { },
  mounted() {
    // 等待 DOM 更新和 YouTube API 加载
    this.$nextTick(() => {
      setTimeout(() => {
        if (window.YT && window.YT.loaded) {
          this.initYouTubePlayer();
        } else {
          // 等待 YouTube API 加载完成
          window.onYouTubeIframeAPIReady = () => {
            this.initYouTubePlayer();
          };
        }
      }, 300);
    });
  },
  methods: {
    toHome() {
      // 获取基础 URL
      const baseUrl = window.location.origin;
      // 打开新标签页
      const newWindow = window.open(baseUrl + '/', '_blank');
      // 确保新窗口获得焦点（兼容 Safari）
      if (newWindow) {
        newWindow.opener = null;
        newWindow.focus();
      }
    },
    onVideoLoad() {
      // 确保 YouTube API 已加载
      if (window.YT && window.YT.Player) {
        this.initYouTubePlayer();
      } else {
        // 如果 API 还未加载，等待一段时间后重试
        setTimeout(() => {
          this.onVideoLoad();
        }, 100);
      }
    },
    // 初始化 YouTube 播放器
    initYouTubePlayer() {
      if (window.YT && window.YT.Player) {
        const iframe = this.$refs.video;
        if (iframe) {
          // 为 iframe 添加唯一 ID
          const playerId = 'youtube-player-' + Date.now();
          iframe.id = playerId;

          this.youtubePlayer = new YT.Player(playerId, {
            events: {
              'onReady': this.onPlayerReady,
              'onStateChange': this.onPlayerStateChange
            }
          });
        }
      } else {
        console.warn('YouTube API not loaded yet');
      }
    },
    submit() {
      fbq('track', 'CompleteRegistration');
      ttq.track('CompleteRegistration');
      dataLayer.push({'event': 'submit successfully'});
    }
  },
  watch: {},
}
</script>

<style lang="less" scoped>
.pre_page {
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
  position: relative;

  .pre_bg {
    position: relative;
    width: 100%;
    height: auto;
    z-index: 10;
    pointer-events: none;
  }

  .video {
    background-color: #000;
    z-index: 2;
    position: absolute;
    top: 4.9%;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    height: 35.6%;
    object-fit: cover;
    user-select: none;
  }

  .earth {
    position: absolute;
    top: 1%;
    right: 4%;
    z-index: 11;
    width: 12%;

    img {
      width: 100%;
      height: auto;
    }
  }

  .down_btn {
    position: absolute;
    top: 42%;
    left: 50%;
    transform: translateX(-50%);
    width: 42%;
    z-index: 11;
    animation: breath 1.2s ease infinite;

    img {
      width: 100%;
      height: auto;
    }
  }

  .claim {
    position: absolute;
    bottom: 25%;
    left: 50%;
    transform: translateX(-50%);
    width: 44%;
    z-index: 11;
    animation: breath 1.2s ease infinite;

    img {
      width: 100%;
      height: auto;
    }
  }
}

@keyframes breath {
  0% {
    transform: translateX(-50%) scale(1);
  }

  50% {
    transform: translateX(-50%) scale(1.1);
  }

  100% {
    transform: translateX(-50%) scale(1);
  }
}
</style>
